import React, { useState } from 'react'
import { Routes, Route } from 'react-router-dom';

// import { useNavigate, useLocation } from "react-router-dom";

import List from './List';
import Add from './AddEdit';
import Edit from './AddEdit';
import Details from './Details';
import { Header, Grid } from 'semantic-ui-react'

function MarketingRoi() {
  // const location = useLocation()
  // const navigate = useNavigate()
  const [reload, setReload] = useState(null)
  return (
    <>

      <Grid.Row columns={2}>
        <Grid.Column>
          <Header as='h2' style={{ marginTop: "50px" }}>
            Chat Gpt Recommendation Log / Data Story Log
            <Header.Subheader>
            Chat Gpt Recommendation Logs (Data Story Logs)
            </Header.Subheader>
          </Header>
        </Grid.Column>
      </Grid.Row>

      
      <Routes>
        <Route path="/" element={<List reload={reload} />} />
        <Route path="edit/:id" element={<Edit setReload={setReload} />} />
        <Route path="details/:id" element={<Details />} />
        <Route path="create" element={<Add setReload={setReload} />} />
      </Routes>
    </>
  );
}

export default MarketingRoi;
